module.exports = __webpack_public_path__ + "static/media/goods3.25df4aad.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods3.png
// module id = 1228
// module chunks = 0